import { ICopilotOption, ICopilotResponse, PromptVersion } from 'interfaces';
import copilotServiceDefaultMessage from './copilot-service-default-message.json';

interface ICopilotServiceDefaultMessage {
	message: string;
	options: ICopilotOption[];
	prompts: string[];
}
export class CopilotServiceDefaultMessage {
	public static defaults(promptVersion: PromptVersion): ICopilotResponse {
		const messages: ICopilotServiceDefaultMessage[] = copilotServiceDefaultMessage.defaults;

		return messages.filter((msg) => msg.prompts.includes(promptVersion))[0] as unknown as ICopilotResponse;
	}
}
